import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import { MDCMenuSurface, Corner } from '@material/menu-surface';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';

import 'next/stylesheets/components/resource/publication-button';

Component('tr-resource-publication-button', {
  mixins: [eventListenerMixin],

  properties: {
    url: String,

    loading: {
      type: Boolean,
      default: false,
    },

    published: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    [this.anchor, this.menuSurface] = this.children;
    this.mdcMenuSurface = new MDCMenuSurface(this.menuSurface);
    this.mdcMenuSurface.setAnchorCorner(Corner.BOTTOM_LEFT);

    // this.surface = this.querySelector('.mdc-menu-surface');
    // this.mdcSurface = new MDCMenuSurface(this.surface);
    // this.mdcSurface.setAnchorCorner(Corner.BOTTOM_END);

    this.listenTo(this.mdcMenuSurface, {
      'MDCMenuSurface:opened': () => {
        this.loading = true;
        $.ajax({
          url: this.url,
          method: 'GET',
          dataType: 'script',
        });
      },
      click: this.handleClick.bind(this),
    });

    this.listenTo(this.anchor, 'click', () => {
      this.mdcMenuSurface.open = !this.mdcMenuSurface.open;
    });
  },

  handleClick(event) {
    if (closest(event.target, '.button-cancel', this)) {
      this.mdcMenuSurface.open = false;
    }
  },

  disconnected() {
    this.stopListening();
    if (this.mdcMenuSurface) this.mdcMenuSurface.destroy();
  },
});
